import React, { useState, useEffect } from "react";
import Etape1 from "../components/Etape1SP";
// import axios from "axios";
import { CheckCircleIcon } from "@heroicons/react/solid";
// import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ReassignerGroup from "../components/ReassignerGroup";
import { apiFetch } from '../utils/apiClient';
import { XCircleIcon } from "@heroicons/react/solid";
// import { Check } from "lucide-react";
// import UsersList from "../components/UsersList";
import { io } from "socket.io-client";
const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); 

const FormScfp = ({
  user,
  membrePersonnel,
  checkGroupAdmin,
  routesConfig,
  enabled
}) => {
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [message, setMessage] = useState("");
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isReadOnlyRh, setIsReadOnlyRh] = useState(false);
  const [couleur, setcouleur] = useState("");
  const [emailUser, setEmailUser] = useState("");
  const [nomUser, setNomUser] = useState("");
  const [idUser, setIdUser] = useState("");
  const [showReassignPopup, setShowReassignPopup] = useState(false);
  const [errorReassign, setErrorReassign] = useState("");
  const [loadingAction, setLoadingAction] = useState(null);
  // const location = useLocation();
  // const selectedForm = location.state?.selectedForm;
  // const page = location.state?.page;
  // const traite = location.state?.traite;

  const navigate = useNavigate();
  const currentStepComponent = "Etape1";
  // const [formId, setFormId] = useState(
  //   location.state?.selectedForm?._id || null
  // );
  const [commentaire, setCommentaire] = useState("");

  // États pour gérer la récupération d’un formulaire sélectionné
  const [selectedForm, setSelectedForm] = useState(null);
  const [formId, setFormId] = useState(null);
  const [page, setPage] = useState(() => sessionStorage.getItem("page") || null);
  const [isLoading, setIsLoading] = useState(false);

  // ✅ useEffect pour récupérer le formulaire depuis sessionStorage et l’API
  useEffect(() => {
    let isMounted = true;

    const numeroFormulaire = sessionStorage.getItem("numeroFormulaire");
    const userId = sessionStorage.getItem("userId");

    const fetchForm = async () => {
      try {
        if (numeroFormulaire && userId) {
          const response = await apiFetch(
            `${process.env.REACT_APP_API_BASE_URL}/selectedFormSP?numeroFormulaire=${numeroFormulaire}&userId=${userId}`
          );

          if (!response.ok) {
            throw new Error("Failed to fetch form data");
          }

          const data = await response.json();

          if (!isMounted) return;
          setSelectedForm(data);
          setFormId(data._id);
        } else {
          console.warn("Missing form identifiers in sessionStorage");
        }
      } catch (error) {
        console.error("Error fetching form data:", error);
      } finally {
        if (!isMounted) return;

        setIsLoading(false);

        // ✅ nettoyage UNE SEULE FOIS, au bon moment
        sessionStorage.removeItem("numeroFormulaire");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("page");
      }
    };

    fetchForm();

    return () => {
      isMounted = false;
    };
  }, []);


  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-SCFP-${yy}${mm}${dd}${randomNumber}`;
  };
  const initialFormData = {
    numeroFormulaire:
      selectedForm?.numeroFormulaire || generateNumeroFormulaire(),
    dateSoumission: new Date().toISOString().split("T")[0],
    // files: [],
    postesVacants: selectedForm?.postesVacants || [],
    commentaires: selectedForm?.commentaires || "",
    traitant: selectedForm?.traitant || [],
    listeDesNotes: selectedForm?.listeDesNotes || [],
    etatDemande: selectedForm?.etatDemande || "",
    SignatureElectronique: selectedForm?.SignatureElectronique || "non",
  };
  const [formData, setFormData] = useState(initialFormData);
  // 🔹 Now conditional rendering


  useEffect(() => {
    if (user && !selectedForm) {
      setFormData((prevData) => ({
        ...prevData,
        userId: user.id,
        matricule: user.employeeId,
        nom: user.displayName,
        courriel: user.mail,
        posteOccupe: user.jobTitle || "",
        // lieuTravail: user.officeLocation
      }));
    }

    if (
      membrePersonnel &&
      Array.isArray(membrePersonnel) && membrePersonnel.length === 1 &&
      !selectedForm
    ) {

      const poste = membrePersonnel[0];
      setFormData((prevData) => ({
        ...prevData,
        rang: poste.rang,
        lieuTravail: poste.lieuTravail,
        fonction: poste.fonction,
        lieuAnciennete: poste.lieuTravail,
        fonctionValidation: poste.fonction,
      }));
    }
    // if (
    //   membrePersonnel &&
    //   Object.keys(membrePersonnel).length > 0 &&
    //   !selectedForm
    // ) {
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     rang: membrePersonnel.Rang,
    //     lieuTravail: membrePersonnel["Lieu de travail"],
    //     lieuAnciennete: membrePersonnel["Lieu de travail"],
    //     fonction: membrePersonnel["Fonction"]
    //   }));
    // }
    if (selectedForm) {
      if (
        (selectedForm.nomFormulaire === "Demande SCFP" &&
          selectedForm.etatDemande !== "Brouillon" &&
          selectedForm.etatDemande !== "Rejeté" &&
          page !== "Mes taches")
        ||
        (
          selectedForm.nomFormulaire === "Demande SCFP" &&
          page === "Mes taches")

      ) {
        setIsReadOnly(true);
      }
      if (
        (selectedForm.nomFormulaire === "Demande SCFP" &&
          (selectedForm.etatDemande === "Approuvé" ||
            selectedForm.etatDemande === "Rejeté") &&
          page === "Mes taches")
        ||
        (
          selectedForm.nomFormulaire === "Demande SCFP" &&
          selectedForm.traitant[selectedForm.traitant.length - 1]?.userId !== user.id &&
          page === "Mes taches")

      ) {
        setIsReadOnlyRh(true);
      }

      setFormData((prevData) => ({
        ...prevData,
        userId: selectedForm.userId,
        matricule: selectedForm.matricule,
        courriel: selectedForm.courriel,
        numeroFormulaire: selectedForm.numeroFormulaire,
        dateSoumission:
          selectedForm.etatDemande === "Brouillon"
            ? new Date().toISOString().split("T")[0]
            : selectedForm.dateSoumission || prevData.dateSoumission,

        nom: selectedForm.nom,
        rang: selectedForm.rang,
        lieuTravail: selectedForm.lieuTravail,
        fonction: selectedForm.fonction,
        lieuAnciennete: selectedForm.lieuAnciennete,
        fonctionValidation: selectedForm.fonctionValidation,
        etatDemande: selectedForm?.etatDemande || "",
        postesVacants: selectedForm?.postesVacants || [],
        SignatureElectronique: selectedForm?.SignatureElectronique || "non",
        traitant: selectedForm?.traitant || [],
        commentaires: selectedForm?.commentaires || "",
        // files:
        //   selectedForm.files?.map((file) => {
        //     const base64Data = `data:${file.contentType};base64,${file.data}`;
        //     return base64ToFile(
        //       base64Data,
        //       file.filename,
        //       file.contentType,
        //       file._id
        //     );
        //   }) || [],
      }));
    }
  }, [user, selectedForm, page, membrePersonnel]); // Add selectedForm to the dependency array

  // État pour stocker les données du formulaire




  //   function getTraite(selectedForm, user, checkGroupAdmin) {
  //   // Cas admin
  //   if(selectedForm){
  //   if (checkGroupAdmin) return true;

  //   // Cas traitant actuel
  //   if (selectedForm.traitant[selectedForm.traitant.length - 1]?.userId === user.id) {
  //     return true;
  //   }
  //  }

  //   return false;
  // }

  // // puis dans ton composant
  // const traite = getTraite(selectedForm, user, checkGroupAdmin);

  const handleChange = (e) => {
    let { name, value } = e.target;
    setErrors("");
    setFormData((prevData) => {
      if (name === "numeroTelephone") {
        // Remove any non-numeric characters (allow only digits)
        value = value.replace(/[^0-9]/g, "");

        // Limit the phone number to 10 digits
        if (value.length > 10) {
          value = value.slice(0, 10);
        }
      }
      // Mise à jour des autres champs
      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  const validateFormEtape1 = () => {
    const newErrors = {};


    if (!formData.nom) {
      newErrors.nom = "Ce champ est requis.";
    }

    if (!formData.courriel) {
      newErrors.courriel = "Ce champ est requis.";
    }
    if (!formData.rang) {
      newErrors.rang = "Ce champ est requis.";
    }
    if (!formData.lieuTravail) {
      newErrors.lieuTravail = "Ce champ est requis.";
    }

    if (!formData.postesVacants || formData.postesVacants.length === 0) {
      newErrors.PostesVacants =
        "Veuillez sélectionner au moins un poste vacant";
    }

    if (formData.postesVacants.length > 0) {
      formData.postesVacants.forEach((posteVacant) => {
        if (!posteVacant.poste) {
          newErrors[`Poste_${posteVacant.choix}`] =
            "Veuillez sélectionner un poste";
        }
      });
    }

    if (formData.SignatureElectronique === "non") {
      newErrors.SignatureElectronique =
        "Veuillez accepter et signer électroniquement pour continuer.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const validateFormEtapeRH = (action) => {
    const newErrors = {};
    if (!formData.fonctionValidation) {
      newErrors.fonctionValidation = "Ce champ est requis.";
    }
    if (!formData.lieuAnciennete) {
      newErrors.lieuAnciennete = "Ce champ est requis.";
    }
    if (action === "Rejeté" && !commentaire) {
      newErrors.commentaireRH = `Veuillez indiquer la raison du rejet dans un commentaire.`
    }
    // if (!formData.surnuméraire) {
    //   newErrors.surnuméraire = "Ce champ est requis.";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p style={{ color: "red" }}>{errors[field]}</p>
    ) : null;
  };

  const handleFormAction = async (e, actionType, next = false) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    let updatedTraitant = [];

    if (actionType === "Approuvé") {
      updatedTraitant = [...(formData.traitant || [])];

      // Étape 1 : Ajouter l'utilisateur actuel comme "Approuvée"
      updatedTraitant.push({
        userId: user.id,
        nom: user.displayName,
        email: user.mail,
        etatDemande: "Approuvé",
        dateHeure: currentDate,
        commentaire: commentaire
      });
    } else if (actionType === "Réassignée") {
      updatedTraitant = [
        ...(formData.traitant || []),
        {
          userId: user.id,
          nom: user.displayName,
          email: user.mail,
          etatDemande: "Réassignée",
          dateHeure: currentDate,
          commentaire: commentaire
        },
        {
          userId: idUser,
          nom: nomUser,
          email: emailUser,
          etatDemande: "En traitement",
          dateHeure: currentDate,
        },
      ];
    } else if (actionType === "Rejeté") {
      updatedTraitant = [
        ...(formData.traitant || []),
        {
          userId: user.id,
          nom: user.displayName,
          email: user.mail,
          etatDemande: "Rejeté",
          dateHeure: currentDate,
          commentaire: commentaire
        },
      ];
    } else {
      updatedTraitant = formData.traitant || [];
    }

    const updatedFormData = {
      ...formData,
      etatDemande:
        actionType === "En traitement" ||
          actionType === "Brouillon" ||
          actionType === "Rejeté" ||
          actionType === "Approuvé" ||
          actionType === "En attente"
          ? actionType
          : formData.etatDemande,
      dateSoumission:
        page === "Mes taches"
          ? formData.dateSoumission
          : currentDate.toISOString(),

      listeDesNotes:
        formData.listeDesNotes?.map((note) =>
          actionType !== "Brouillon"
            ? note.ancien
              ? note
              : { ...note, ancien: true }
            : note
        ) || [],
      traitant: updatedTraitant,
    };

    // const method = (location.state?.selectedForm || (next===true && updatedFormData.etatDemande !== ""))? "PUT" : "POST"; // Use PUT if selectedForm exists, otherwise POST
    const method = formId ? "PUT" : "POST";
    const url = formId
      ? `${process.env.REACT_APP_API_BASE_URL}/form/${formId}/Scfp` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/form/Scfp`; // Use POST for creating a new form

    const formDataToSend = new FormData();
    // Append regular form fields to FormData
    formDataToSend.append("updatedFormData", JSON.stringify(updatedFormData));

    // 🔹 ETRFiles
    if (formData.files?.length > 0) {
      formData.files.forEach((file, fileIndex) => {
        if (file._id) {
          formDataToSend.append(`files[${fileIndex}][_id]`, file._id);
        } else {
          const blob = new Blob([file], { type: file.type });
          formDataToSend.append(`files[${fileIndex}]`, blob, file.name);
        }
      });
    }

    // Send the form data to the backend
    try {
      const response = await apiFetch(url, {
        method: method,
        body: formDataToSend,
      });

      if (response.ok) {
        const data = await response.json();

        // Store the ID if this was a new form
        if (!formId && data.newForm?._id) {
          setFormId(data.newForm._id);
        }

        if (next === false) {
          setIsSubmitted(true); // Show popup
          // Hide popup after 3 seconds
          await new Promise((resolve) => {
            setTimeout(() => {
              setIsSubmitted(false); // Hide the popup after timeout
              resolve(); // Resolve the promise after 3 seconds
            }, 2000);
          });
        }
        if(updatedFormData.etatDemande !== "Brouillon"){
          if (socket) {
          socket.emit("requestUpdated");
        }
        }
        if (next === false) {
          if (updatedFormData.etatDemande !== "Brouillon" && updatedFormData.etatDemande !== "") {
            if (page === "Mes taches") {
              // navigate("/taches", { state: { selectedForm: null } });
              window.close()
            } else {
              navigate("/demande", { state: { selectedForm: null } });
            }
          }
        }

        // navigate("/demande", { state: { selectedForm: null } });

        // console.log(`Form data ${actionType.toLowerCase()} successfully!`);
      } else {
        console.error(`Failed to ${actionType.toLowerCase()} form data.`);
      }
    } catch (error) {
      console.error(`Error ${actionType.toLowerCase()} form data:`, error);
    }
  };

  const handleSave = (e, next = false) => {
     if (loadingAction) return;
    setLoadingAction("save");
    handleFormAction(e, "Brouillon", next); // Use "Enregistrer" for save action
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis."
    );
    setcouleur("text-grey-600");
    setErrors("");
    setTimeout(() => setLoadingAction(null), 1000); // optionnel
  };

  const handleSubmit = (e) => {
    if (loadingAction) return;
    if (!validateFormEtape1()) return;
    handleFormAction(e, "En attente"); // Use "Enregistrer" for save action
    setLoadingAction("submit");
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
    setErrors("");
    setTimeout(() => setLoadingAction(null), 1000); // optionnel
  };

  const handleApprouve = (e) => {
    if (!validateFormEtapeRH("Approuvé")) return;
    handleFormAction(e, "Approuvé"); // Use "Enregistrer" for save action
    setMessage("Succès ! Le formulaire a été Approuvé.");
    setcouleur("text-green-600");
    setErrors("");
  };
  const handleRejeter = (e) => {
    if (!validateFormEtapeRH("Rejeté")) return;
    handleFormAction(e, "Rejeté"); // Use "Enregistrer" for save action
    setMessage("Le formulaire a été Rejeté.");
    setcouleur("text-red-700");
    setErrors("");
  };
  const handleReassign = (e) => {
    if (nomUser === "") {
      setErrorReassign("ce champs est requis");
    } else if (nomUser === selectedForm.nom) {
      setErrorReassign("La demande ne peut pas être réassignée à son auteur.");
    } else {
      setShowReassignPopup(false);
      handleFormAction(e, "Réassignée"); // Use "Enregistrer" for save action
      setMessage(`Succès ! Le formulaire a été Réassignée a ${nomUser}`);
      setcouleur("text-green-600");
      setErrors("");
    }
  };

  const handleUserSelect = (user) => {
    if (user) {
      setErrorReassign("");
      setNomUser(user.nom);
      setEmailUser(user.email);
      setIdUser(user.userId);
    } else {
      setNomUser("");
      setEmailUser("");
      setIdUser("");
    }

  };

  const handleReassignClick = () => {
    if (!validateFormEtapeRH("Réassignée")) return;
    setShowReassignPopup(true);
  };
  const handleReassignCancel = () => {
    setShowReassignPopup(false);
    setNomUser("");
    setEmailUser("");
    setIdUser("");
    setErrorReassign("");
  };

  const renderStep = () => {
    switch (currentStepComponent) {
      case "Etape1":
        return (
          <Etape1
            renderError={renderError}
            user={user}
            formData={formData}
            handleChange={handleChange}
            isReadOnly={isReadOnly}
            isReadOnlyRh={isReadOnlyRh}
            setFormData={setFormData}
            page={page}
            setCommentaire={setCommentaire}
            commentaire={commentaire}
            routesConfig={routesConfig}
            formulaire={"Scfp"}
            membrePersonnel={membrePersonnel}
          />
        );
      default:
        return (
          <Etape1
            renderError={renderError}
            user={user}
            formData={formData}
            handleChange={handleChange}
            isReadOnly={isReadOnly}
            isReadOnlyRh={isReadOnlyRh}
            setFormData={setFormData}
            page={page}
            setCommentaire={setCommentaire}
            commentaire={commentaire}
            routesConfig={routesConfig}
            formulaire={"Scfp"}
            membrePersonnel={membrePersonnel}
          />
        );
    }
  };

  if (
    (!enabled && !selectedForm && page !== "Mes taches") ||
    (!enabled && selectedForm && selectedForm.etatDemande === "Brouillon" && page !== "Mes taches")
  ) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
        <XCircleIcon className="h-16 w-16 text-red-500 mb-4 animate-pulse" />
        <h3 className="text-2xl font-bold text-red-600 mb-2">
          Formulaire SCFP fermé
        </h3>
        <p className="text-gray-700 max-w-md">
          Vous ne pouvez pas accéder à ce formulaire pour le moment.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-2 bg-gray-100 rounded-lg shadow-lg">
      {renderStep()}

      <div className="flex justify-start mt-10 p-4 mb-4">
        <div className="flex space-x-4">
          {(formData.etatDemande === "Brouillon" ||
            formData.etatDemande === "") && (
              <button
                type="button"
                disabled={loadingAction !== null}
              className={`
                    flex items-center justify-center gap-2
                    px-5 py-2.5 rounded-xl text-sm font-medium
                    transition-all duration-200
                    shadow-sm
                    ${
                      loadingAction
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-gray-700 text-white hover:bg-gray-600 active:scale-95"
                    }
                    `} 
                onClick={(e) => handleSave(e, false)}
              >
                {loadingAction === "save" && (
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  )}
                Enregistrer
              </button>
            )}

          {currentStepComponent === "Etape1" &&
            (formData.etatDemande === "Brouillon" ||
              formData.etatDemande === "" ||
              (formData.etatDemande === "Rejeté" && page !== "Mes taches")) && enabled && (
              <button
                type="button"
                disabled={loadingAction !== null}
                className={`
                    flex items-center justify-center gap-2
                    px-5 py-2.5 rounded-xl text-sm font-medium
                    transition-all duration-200
                    shadow-sm
                    ${
                      loadingAction
                        ? "bg-green-300 text-white cursor-not-allowed"
                        : "bg-green-600 text-white hover:bg-green-500 active:scale-95"
                    }
                `}
                onClick={handleSubmit}
              >
                {loadingAction === "submit" && (
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                Soumettre
              </button>
            )}

          {currentStepComponent === "Etape1" &&
            page === "Mes taches" &&
            // selectedForm.etatDemande !== "Rejeté" &&
            // selectedForm.etatDemande !== "Approuvé" &&
            // traite && 
            (
              <button
                type="button"
                className="ml-50 mt-5 w-24 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-400"
                onClick={handleReassignClick}
              >
                Réassigner
              </button>
            )}
          {currentStepComponent === "Etape1" &&
            page === "Mes taches" &&
            // selectedForm.etatDemande !== "Rejeté" &&
            // selectedForm.etatDemande !== "Approuvé" &&
            // traite && 
            (
              <button
                type="button"
                className="mt-5 w-24 py-2 bg-red-600 text-white rounded-md hover:bg-red-400"
                onClick={handleRejeter}
              >
                Rejeter
              </button>
            )}
          {currentStepComponent === "Etape1" &&
            page === "Mes taches" &&
            // selectedForm.etatDemande !== "Rejeté" &&
            // selectedForm.etatDemande !== "Approuvé" &&
            // traite && 
            (
              <button
                type="button"
                className="mt-5 w-24 py-2 bg-green-600 text-white rounded-md hover:bg-green-400"
                onClick={handleApprouve}
              >
                Approuver
              </button>
            )}
        </div>
      </div>

      {showReassignPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-1/3">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">
              Réassigner la tâche
            </h2>
            <label className="block mb-2 text-sm font-medium text-gray-600">
              Email:
            </label>
            <ReassignerGroup
              nomFormulaire={"Séance de placement"}
              onUserSelect={handleUserSelect}
            />
            {errorReassign && (
              <p className="text-red-500 text-sm mb-4">{errorReassign}</p>
            )}
            <label className="block mt-4 mb-2 text-sm font-medium text-gray-600">
              Nom:
            </label>
            <input
              type="text"
              value={nomUser}
              disabled
              className="w-1/2 p-3 border border-gray-300 rounded-lg text-gray-700 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400"
              required
            />
            <div className="flex justify-end mt-6 space-x-4">
              <button
                className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                onClick={handleReassignCancel}
              >
                Annuler
              </button>
              <button
                className="px-5 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                onClick={handleReassign}
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50">
          <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          <p className="ml-3 text-gray-700 font-medium">
            Chargement en cours...
          </p>
        </div>
      )}
      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormScfp;
